import { licenseService } from '_services';
import { session } from '_helpers';
import { ACTIONS_LICENSE } from '_constants/license.constants';
import alertActions from './alert.actions';

export const receiveLicenses = (licenses) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < licenses.length; i++) {
    byIdObjectToDispatch[licenses[i].licenseID] = licenses[i];
  }

  return {
    type: ACTIONS_LICENSE.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteLicense = (licenseId) => ({
  type: ACTIONS_LICENSE.DELETE,
  byId: { [licenseId]: null }
});

const getLicenses = (accountID) => async (dispatch) => {
  try {
    const resp = await licenseService.getAll(accountID);
    if (resp?.[0]?.licenseID) {
      dispatch(receiveLicenses(resp));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error retrieving licences.'));
  }
  return null;
};

const getLicense = (licenseID) => async (dispatch) => {
  try {
    const resp = await licenseService.getById(licenseID);
    if (resp?.licenseID) {
      dispatch(receiveLicenses([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const addLicense = (license) => async (dispatch) => {
  try {
    const resp = await licenseService.create(license);
    if (resp?.[0]?.licenseID) {
      dispatch(receiveLicenses([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const updLicense = (license) => async (dispatch) => {
  try {
    const resp = await licenseService.update(license);
    if (resp?.licenseID) {
      dispatch(receiveLicenses([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const linkLicense = (license) => async (dispatch) => {
  try {
    const resp = await licenseService.link(license);
    if (resp?.licenseID) {
      dispatch(receiveLicenses([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const unAssignLicense = (licenseID) => async (dispatch) => {
  try {
    const resp = await licenseService.unAssign(licenseID);
    if (resp?.licenseID) {
      dispatch(receiveLicenses([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const delLicense = (licenseID) => async (dispatch) => {
  try {
    const resp = await licenseService.delete(licenseID);
    if (resp?.licenseID) {
      dispatch(deleteLicense(resp.licenseID));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error removing license #${licenseID}.`));
  }
  return null;
};

const licenseActions = {
  getLicenses,
  getLicense,
  addLicense,
  delLicense,
  updLicense,
  linkLicense,
  unAssignLicense,
};

export default licenseActions;
